// Environment Configuration
const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || 'https://backend-app.ddev.site/api',

  // App Configuration
  APP_NAME: process.env.REACT_APP_NAME || 'Intake Management',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',

  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  // Feature Flags (can be controlled via environment)
  ENABLE_SOCIAL_LOGIN: process.env.REACT_APP_ENABLE_SOCIAL_LOGIN !== 'false',
  ENABLE_REGISTRATION: process.env.REACT_APP_ENABLE_REGISTRATION !== 'false',

  // Other configurations
  DEFAULT_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000'),
  MAX_FILE_SIZE: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '10485760'), // 10MB
};

// Export individual values for backward compatibility
export const API_URL = config.API_URL;
export const APP_NAME = config.APP_NAME;
export const APP_VERSION = config.APP_VERSION;

// Export the full config object
export default config;
